/** Rival OAuth is a deployed-stack capability. Local Ros always keeps its developer user picker. */
export function isRivalOAuthEnabled(options: {
  isLocal: boolean
  rivalOAuthAvailable: boolean
  featureFlagEnabled: boolean
}): boolean {
  return !options.isLocal && options.rivalOAuthAvailable && options.featureFlagEnabled
}
